<template>
  <v-container
    fluid
    pa-0
    ma-0
    fill-height
    class="wask_loader bg_half_transparent test_red"
  >
    <v-row justify="center" align="center" class="fill-height">
      <ring-loader :color="$store.getters.appInfo.primary" />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SpinnerLoader",
};
</script>
